// Lib
import React, { useEffect, useState, useCallback } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';

// Components
import Input from '../../../../Field/Input';
import Feather from '../../../../Feather';

// Styles
import { useStyles } from './EventStyles';

const Event = ({
  onChangeEvent,
  shippingDetails,
  onRemoveFile,
  onChangeFile,
  incorrectFormatMessage,
  inputFileRef,
}) => {
  const { classes, cx } = useStyles();
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);

  const { event, schedule } = shippingDetails;

  const isRecurring =
    schedule?.toLowerCase().includes('monthly') ||
    schedule?.toLowerCase().includes('weekly');

  useEffect(() => {
    if (event?.name || event?.boothNumber) {
      setCheckBoxChecked(true);
    }
  }, [event, setCheckBoxChecked]);

  const onChangeCheckBox = useCallback(
    ({ target }) => {
      setCheckBoxChecked(target.checked);
    },
    [setCheckBoxChecked],
  );

  return (
    <>
      <FormControlLabel
        disabled={isRecurring}
        className={classes.checkBox}
        label="Order Is For An Event/Conference"
        control={
          <Checkbox
            checked={checkBoxChecked && !isRecurring}
            onChange={onChangeCheckBox}
          />
        }
      />
      {checkBoxChecked && !isRecurring && (
        <div className={classes.eventContainer}>
          <Input
            value={event.name}
            label="Event Name"
            name="name"
            onChange={onChangeEvent}
            maxLength={256}
          />
          <Input
            value={event.boothNumber}
            label="Booth Number"
            name="boothNumber"
            onChange={onChangeEvent}
            dir="rtl"
            maxLength={10}
          />
          <div>
            <Input
              ref={inputFileRef}
              accept="application/pdf"
              type="file"
              label="Shipping Labels"
              hidden
              onChange={onChangeFile}
              className={event.file.name ? classes.fileInput : ''}
              customPlaceholder={
                event.file.name ? (
                  <Box
                    className={classes.customPlaceholder}
                    display="flex"
                    alignItems="center">
                    <Feather nativeColor type="file" className={classes.icon} />
                    <div className={classes.placeholderText}>
                      {event.file.name}
                    </div>
                    <Feather
                      onClick={onRemoveFile}
                      type="delete"
                      className={classes.clearIcon}
                    />
                  </Box>
                ) : (
                  <Box
                    className={classes.customPlaceholder}
                    display="flex"
                    alignItems="center">
                    <Feather
                      printType="stroke"
                      type="download"
                      className={classes.icon}
                    />
                    Upload PDF File
                  </Box>
                )
              }
            />
            {incorrectFormatMessage && (
              <div className={classes.errorContainer}>
                <Feather
                  nativeColor
                  type="error"
                  className={cx(classes.errorIcon, classes.errorIconSize)}
                />
                <span className={classes.error}>{incorrectFormatMessage}</span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Event;
